module.exports = __webpack_public_path__ + "img/list2.40f76111.jpg";